module.exports = __webpack_public_path__ + "static/media/6.42cb816b.svg";